/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
// import core & vendor packages below
import { Row, Col, Form, Button, FormControl, InputGroup, Accordion } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

// import components below
import FormUI from 'components/UI/FormUI';
import { ReactComponent as MagnifyingGlassSVG } from 'assets/svg/magnifying_glass.svg';
import { getPatient } from 'reducers/patientReducer';
import { useSelector } from 'react-redux';
import { ReactComponent as AddGroupSVG } from 'assets/svg/add-group.svg';
import { selectPatientData } from 'reducers/patientReducer';
import axios from 'axios';

// import assets below
import './Filter.scss';

// main component
const SearchPatientFilter = ({ state, setState, handleTabOnChange }) => {
  const dispatch = useDispatch();
  const data = useSelector(selectPatientData);

  const [erPatient, setErPatient] = useState([]);

  const [searchData, setSearchData] = useState({
    id: '',
    patient_name: '',
    date_admitted: '',
    currently_admitted: false,
    currently_er_patient: false,
  });

  const onChangeHandler = (event) => {
    const searchedWord = event.target.value;

    const newFilter = data.filter((value) => {
      return (
        value.full_name.toLowerCase().includes(searchedWord.toLowerCase()) ||
        value.MRN.toLowerCase().includes(searchedWord.toLowerCase())
      );
    });

    if (searchedWord.length > 0) {
      setState(newFilter);
    } else {
      setState(erPatient);
    }
  };

  const handleChange = (key) => (e) => {
    if (e.target.type === 'checkbox') {
      setSearchData((prevState) => {
        return {
          ...prevState,
          [key]: e.target.checked,
        };
      });

      if (key === 'currently_admitted' && e.target.checked) {
        const filterERPatients = state.filter((patient) => patient.patient_status === 'admitted');
        console.log('show all ER patients...', filterERPatients);
        setState(filterERPatients);
        return;
      } else if (key === 'currently_er_patient' && e.target.checked) {
        const filterERPatients = state.filter((patient) => patient.patient_status === 'emergency');
        console.log('show all ER patients...', filterERPatients);
        setState(filterERPatients);
        return;
      } else {
        setState(erPatient);
      }

      return;
    }

    setSearchData({
      ...searchData,
      [key]: e.target.value,
    });
  };

  const search = (reset = false) => {
    axios
      .get('/patient', {
        params: {
          MRN: reset ? '' : searchData.id,
          full_name: reset ? '' : searchData.patient_name,
          admission_date: reset ? '' : searchData.date_admitted,
          patient_status: ['emergency', 'for_discharge', 'for_admission_referred_from_opd'],
        },
      })
      .then((response) => {
        setState(response.data.data);
      }, [])
      .catch((err) => {
        console.log('AXIOS ERROR: ', err);
      });
  };

  useEffect(() => {
    dispatch(getPatient());

    axios
      .get('/patient', {
        params: {
          patient_status: ['emergency', 'for_discharge', 'for_admission_referred_from_opd'],
        },
      })
      .then((response) => {
        setState(response.data.data);
        setErPatient(response.data.data);
      }, [])
      .catch((err) => {
        console.log('AXIOS ERROR: ', err);
      });
  }, []);

  return (
    <div className='searchPatientFilter'>
      <FormUI>
        {/* Basic Search */}
        <Row>
          <Col>
            <Form.Group className='mb-3 mt-3 basic-search'>
              <Form.Label>Basic Search</Form.Label>
              <InputGroup>
                <InputGroup.Text className='bg-grey'>
                  <MagnifyingGlassSVG />
                </InputGroup.Text>
                <FormControl
                  type='search'
                  className='bg-grey'
                  placeholder='Search via Last Name or PIN…'
                  value={searchData.basic_search}
                  onChange={onChangeHandler}
                />
                <Button variant='search'>SEARCH</Button>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col>
            <div className='buttonWrapper'>
              {/* <Link
                className='btn btn-dark-blue me-3'
                to='/dashboard/admissions/create-temporary-profile'
              >
                <AddGroupSVG />
                <span>Create Temporary Profile</span>
              </Link> */}
              <Link
                className='btn btn-light-blue px-3'
                to='/dashboard/emergency-department/create-new-patient'
              >
                <AddGroupSVG />
                <span>Register New Patient</span>
              </Link>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <Accordion className='mb-3 advanced-search'>
              <Accordion.Item eventKey='0'>
                <Accordion.Header>Advance Search</Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={3}>
                      <Form.Group className='mb-4'>
                        <Form.Label>MRN / PIN</Form.Label>
                        <FormControl
                          type='text'
                          className='bg-white'
                          placeholder='Enter Here'
                          value={searchData.id}
                          onChange={handleChange('id')}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className='mb-4' style={{ width: '100%' }}>
                        <Form.Label>Patient Name</Form.Label>
                        <FormControl
                          type='text'
                          className='bg-white'
                          placeholder='Enter Patient Name'
                          value={searchData.patient_name}
                          onChange={handleChange('patient_name')}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-4'>
                        <Form.Label>Date Admitted</Form.Label>
                        <FormControl
                          type='date'
                          className='bg-white'
                          placeholder='Enter Here'
                          value={searchData.date_admitted}
                          onChange={handleChange('date_admitted')}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <div className='buttonWrapper'>
                      <Form.Check
                        type={'checkbox'}
                        id={`admitted`}
                        label={`Currently Admitted`}
                        value={searchData.currently_admitted}
                        onChange={handleChange('currently_admitted')}
                      />
                      <Form.Check
                        type={'checkbox'}
                        id={`er-patient`}
                        label={`Currently an ER Patient`}
                        value={searchData.currently_er_patient}
                        onChange={handleChange('currently_er_patient')}
                      />

                      <Button variant='search' onClick={() => search()}>
                        SEARCH
                      </Button>

                      <Button
                        variant='clear'
                        onClick={() => {
                          setSearchData({
                            id: '',
                            patient_name: '',
                            date_admitted: '',
                            currently_admitted: false,
                            currently_er_patient: false,
                          });

                          search(true);
                        }}
                      >
                        CLEAR
                      </Button>
                    </div>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </FormUI>
    </div>
  );
};

export default SearchPatientFilter;
